import React from 'react';
import { DatePicker } from 'antd';
import moment from 'moment';

const { RangePicker } = DatePicker;

const DatePickerUi = ({ onChange = () => {}, otherProps }) => {
	const disabledDate = current => {
		return current && current > moment().endOf('day');
	};

	return (
		<div className="space-custom-class">
			<RangePicker onChange={onChange} style={{ width: '100%' }} disabledDate={disabledDate} {...otherProps} />
		</div>
	);
};

export default DatePickerUi;
